<template>
  <div class="pl-1 mb-2 ml-4">
    <template v-for="(action, i) in actions">
      <template v-if="action.childrens">
        <b-dropdown
          :key="i"
          v-if="action.condition && isExsit(action.code)"
          :text="action.text"
          :variant="action.variant"
          :class="action.class"
          class="action-dropdown mr-2 mb-2"
          size="sm"
        >
          <template v-for="(child, i1) in action.childrens">
            <b-dropdown-item
              :key="i1"
              v-if="child.condition && isExsit(action.code)"
              @click="child.action"
            >
              {{ child.text }}
            </b-dropdown-item>
          </template>
        </b-dropdown>
      </template>
      <template v-else>
        <b-button
          :key="i"
          v-if="action.condition && isExsit(action.code)"
          @click="action.action"
          class="mr-2 mb-2"
          :class="action.class"
          :variant="action.variant"
        >
          {{ action.text }}
        </b-button>
      </template>
    </template>
  </div>
</template>

<script>
  export default {
    props: ['actions', 'excepts'],
    data() {
      return {}
    },
    async created() {},
    methods: {
      isExsit(code) {
        return !this.excepts?.includes(code)
      },
    },
  }
</script>

<style scoped>
  ::v-deep .dropdown.action-dropdown .dropdown-toggle::after {
    display: none !important;
  }
  ::v-deep .dropdown.action-dropdown > .btn,
  .dropdown .btn-sm {
    padding: 7px 15px !important;
    height: 35px;
  }
  ::v-deep .dropdown.action-dropdown .dropdown-menu {
    outline: none;
  }
  ::v-deep .dropdown.dropdown.action-dropdown .dropdown-item {
    width: 90%;
  }
  @media (max-width: 415px) {
    .btn-group {
      padding-bottom: 0;
    }
  }
</style>
